<template>
    <div>
        <div v-if="show" class="school-box school-box-diff">
            <Breadcrumb></Breadcrumb>
            <el-row class="zy-school" type="flex" justify="space-between">
                <el-col :span="16"> 
                    <div>
                        <el-tabs type="border-card" slot="content" class="rank-box zy-list" @tab-click="handleChangeCard">
                            <el-tab-pane :label="card" v-for="(card,index) in cardList" :key="index" v-model="activeCardIndex">
                                <div class="search-img header-search">
                                    <el-input placeholder="查学校" v-model="searchSchool.scl_name" @input="searchSchoolListHandler()">
                                        <template slot="append">
                                            <img src="../../assets/images/sousuo.png" alt="搜索" @click="searchSchoolListHandler" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="!isShowSearch">
                                            <img src="../../assets/images/sousuo-diff.png" alt="搜索" @click="searchSchoolListHandler" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="isShowSearch">
                                        </template>
                                    </el-input>
                                </div>
                                <!-- <div class="province-list" v-if="index == 0">
                                    <div class="title-box">学历层次：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="670" viewBox="0 0 670 30" v-if="typeList2.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList6" :key="'id1' + index" :class="activeTag7 == index?'active-tag':''" @click="activeTagHandler7(index)">{{item.dic_value}}</a>
                                        <a v-for="(item,index) in typeList2" :class="activeTag3 == index?'active-tag':''" @click="activeTagHandler3(index)" :key="'id3' + index">{{item.dic_value}}</a>
                                    </div>
                                </div> -->
                                <div class="province-list" v-if="index == 1 || index == 2">
                                    <div class="title-box">学历层次：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="670" viewBox="0 0 670 30" v-if="typeList2.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList2" :class="activeTag3 == index?'active-tag':''" @click="activeTagHandler3(index)" :key="'id3' + index">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="index == 1">
                                    <div class="title-box">院校类型：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList3.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList3" :key="'id1' + index" :class="activeTag4 == index?'active-tag':''" @click="activeTagHandler4(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list">
                                    <div class="title-box">省份：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="84" width="670" viewBox="0 0 670 84" v-if="provinceList.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                        <rect x="10" y="60" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in provinceList" :key="'id' + index" :class="activeTag == index?'active-tag':''" @click="activeTagHandler(index)">{{item.name}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="index == 0">
                                    <div class="title-box">院校类型：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList" :key="'id1' + index" :class="activeTag1 == index?'active-tag':''" @click="activeTagHandler1(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <!-- <div class="province-list" v-if="index == 2">
                                    <div class="title-box">院校等级：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="84" width="670" viewBox="0 0 670 84" v-if="typeList4.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                        <rect x="10" y="60" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList4" :key="'id' + index" :class="activeTag5 == index?'active-tag':''" @click="activeTagHandler5(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="index == 2">
                                    <div class="title-box">双高院校：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList5.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList5" :key="'id1' + index" :class="activeTag6 == index?'active-tag':''" @click="activeTagHandler6(index)">{{item.dic_value}}</a>
                                    </div>
                                </div> -->
                                <div class="province-list" v-if="showSearchAll">
                                    <div class="title-box">办学类型：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList1.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList1" :class="activeTag2 == index?'active-tag':''" @click="activeTagHandler2(index)" :key="'id2' + index">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="showSearchAll && index == 0">
                                    <div class="title-box">招生批次：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList9.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList9" :key="'id1' + index" :class="activeTag10 == index?'active-tag':''" @click="activeTagHandler10(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="showSearchAll && index == 0">
                                    <div class="title-box">院校层次：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList6.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList6" :key="'id1' + index" :class="activeTag7 == index?'active-tag':''" @click="activeTagHandler7(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="showSearchAll && index == 0">
                                    <div class="title-box">硕博点：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList7.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList7" :key="'id1' + index" :class="activeTag8 == index?'active-tag':''" @click="activeTagHandler8(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="province-list" v-if="showSearchAll && index == 0">
                                    <div class="title-box">博士生点：</div>
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList8.length == 1">
                                        <rect x="10" y="0" width="670" height="20" />
                                        <rect x="10" y="30" width="670" height="20" />
                                    </ContentLoader>
                                    <div class="province-name" v-else>
                                        <a v-for="(item,index) in typeList8" :key="'id1' + index" :class="activeTag9 == index?'active-tag':''" @click="activeTagHandler9(index)">{{item.dic_value}}</a>
                                    </div>
                                </div>
                                <div class="choice-box" @click="showSearchAllhandler">查看全部筛选条件<i :class="showSearchAll? 'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
                                <!-- <div v-if="!searchSchoolStatus1" style="margin-top: 20px">
                                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="110" width="670" viewBox="0 0 670 110" v-for="item in 20" :key="item">
                                        <rect x="80" y="30" width="117" height="20" />
                                        <rect x="80" y="60" width="140" height="23" />
                                        <rect x="580" y="50" width="100" height="30" />
                                        <circle cx="35" cy="60" r="32" />
                                        <rect x="80" y="109" width="725" height="1" />
                                    </ContentLoader>
                                </div> -->
                                <el-row class="collapse-box" v-if="searchSchoolStatus && index == activeCardIndex">
                                    <div class="collapse-list" v-for="(item,index) in schoolList" :key="index">
                                        <el-col :span="3">
                                        <img :src="item.logo" alt="大学logo" ref="schoolImg" @error="nofindImg(index)">
                                        <transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
                                            <div class="ball" v-if="showImage">
                                                <img class="active-img-inner active-img-inner-hook" :src="schoolList[showImageIndex].logo" alt="大学logo">
                                            </div>
                                        </transition>
                                        </el-col>
                                        <el-col :span="17">
                                        <div class="zytb-school-name">
                                            <span class="zytb-school-title" @click="schoolDetailHandler(item.scl_id)">{{item.scl_name}}</span><img src="../../assets/images/wz.png" alt="位置" v-if="item.city_name">
                                            <span v-if="item.city_name">{{item.province_name == '北京' || item.province_name == '天津' || item.province_name == '上海' || item.province_name == '重庆' ? '' : item.province_name}}{{item.city_name}}</span>
                                        </div>
                                        <div class="zytb-school-tag">
                                            <span v-if="item.school_nature_type">{{item.school_nature_type}}</span>
                                            <span v-if="item.school_type">{{item.school_type}}</span>
                                            <span v-if="item.school_nature">{{item.school_nature}}</span>
                                            <span v-if="item.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                                            <span v-if="item.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                                            <span v-if="item.dual_class != '38003' && item.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                                            <span v-if="item.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                                            <span v-if="item.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                                        </div>
                                        </el-col>
                                        <el-col :span="4">
                                            <el-button class="school-compare" v-if="!item.pk" @click.native="addCompare(item,index)" v-click-with-auth-login>
                                                <img src="../../assets/images/add.png" alt="加入对比">
                                                加入对比
                                            </el-button>
                                            <el-button class="school-compare-diff" v-else @click="removeCompare(item,index)">
                                                <img src="../../assets/images/cancel.png" alt="取消对比">
                                                取消对比
                                            </el-button>
                                        </el-col>
                                        <div class="con-clear"></div>
                                        <el-row class="con-line"></el-row>
                                    </div>
                                    <el-pagination
                                        background
                                        layout="prev, pager, next, jumper"
                                        :total="totalData" :page-size="20" @current-change="getDiffSchoolListHandler" :current-page.sync="currentPage" v-if="totalData > 0">
                                    </el-pagination>
                                </el-row>
                                <div v-if="!searchSchoolStatus" class="no-data-box">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>没有查询到学校</p>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-col>
                <el-col :span="8" class="zyb-box">
                    <SchoolRank></SchoolRank> 
                    <News></News>
                </el-col>
            </el-row>
        </div>
        <router-view></router-view>
    </div>
    
</template>

<script>
import { getSearchDic } from "@/api/zhiyuan"
import { getSchoolList, getArtSchoolList, getHighSchoolList } from "@/api/school"
import { ContentLoader } from 'vue-content-loader'
import { mapState } from 'vuex'
export default {
    name: 'school',
    components: {
        ContentLoader
    },
    data() {
        return {
            show: true,
            currentPage: 1,
            isShowSearch: false,
            levelList: [
                {name : "全部"},
            ],
            provinceList: [
                {name : "全部"},
            ],
            typeList: [
                {dic_value:'全部'},
            ],
            typeList1: [
                {dic_value:'全部'},
            ],
            typeList2: [{dic_value:'全部'}],
            typeList3: [{dic_value:'全部'}],
            typeList4: [{dic_value:'全部'}],
            typeList5: [{dic_value:'全部'}],
            typeList6: [{dic_value:'全部'}],
            typeList7: [{dic_value:'全部'}],
            typeList8: [{dic_value:'全部'}],
            typeList9: [{dic_value:'全部'}],
			showSearchAll: false,
			activeTag: 0,
			activeTag1: 0,
			activeTag2: 0,
            activeTag3: 0,
            activeTag4: 0,
            activeTag5: 0,
            activeTag6: 0,
            activeTag7: 0,
            activeTag8: 0,
            activeTag9: 0,
            activeTag10: 0,
            totalData: 0,
            schoolList: [],
            searchSchool: {
                scl_name: '',
                province_id: '',
                scl_type: '', 
                scl_nature: '', 
                scl_nature_type: '', 
                f211: '', 
                f985: '', 
                dual_class: '',
                local_batch_type: ''
            },
            searchArtSchool: {
                scl_name: '',
                province_id: '',
                scl_nature: '',
                scl_nature_type: '',
                art_type: '',
            },
            searchHighSchool: {
                scl_name: '',
                scl_type: '',
                colleges_level: '',
                doublehigh: '',
                scl_nature: '',
                scl_nature_type: '',
                art_type: '',
                province: ''
            },
            searchSchoolStatus: true,
            searchSchoolStatus1: false,
            newsList: [],
            showImage: false,
            showImageIndex: null,
            cardList:['文化生','艺术生','高职单招'],
            // cardList:['文化生','艺术生'],
            activeCardIndex: 0,
            type_edu: {},
        }
    },
    computed: {
        ...mapState({
            requestCount: state => state.user.requestCount,
            compareSchoolList: state => state.user.compareSchoolList,
            provinceCode: state => state.user.provinceCode,
        })
    },
    watch: {
        requestCount (newVal) {
            if(newVal > 0) {
                this.searchSchoolStatus1 = false;
            } else {
                this.searchSchoolStatus1 = true;
            }
        },
        compareSchoolList(newVal) {
            this.schoolList.map((item,index) => {
                let findIndex = newVal.findIndex(item1 => item1 == item.scl_id);
                if(findIndex != -1) {
                    this.$set(this.schoolList, index, {...this.schoolList[index], pk: true});
                } else {
                    this.$set(this.schoolList, index, {...this.schoolList[index], pk: false});
                }
            })
        },
        provinceCode (newVal) {
            if(newVal != '') {
                if(this.activeCardIndex == '2') {
                    this.currentPage = 1;
                    this.getHighSchoolListHandler('1');
                }
            }
        },
    },
    created() {
        localStorage.setItem("compareSchoolList","");
        this.$store.commit('user/ADDCOUNT', 0);
        this.getSearchDicHandler();
        setTimeout(()=>{
            this.getSchoolListHandler('1');
        }, 200)
    },
	methods:{
		schoolDetailHandler(scl_id) {
			this.$router.push({
				path:'/schoolDetail',
                query: {
                    scl_id: scl_id
                }
			})
		},
		showSearchAllhandler() {
			this.showSearchAll = !this.showSearchAll;
		},
		activeTagHandler(index) {
			this.activeTag = index;
            if(this.activeCardIndex == 0) {
                this.searchSchool.province_id = this.provinceList[index].provinceid;
            } else if(this.activeCardIndex == 1) {
                this.searchArtSchool.province_id = this.provinceList[index].provinceid;
            } else {
                console.log(this.provinceList[index])
                this.searchHighSchool.province = this.provinceList[index].provinceid;
            }
            this.resetGetSchoolListHandler();
		},
		activeTagHandler1(index) {
			this.activeTag1 = index;
            if(this.activeCardIndex == 0) {
                this.searchSchool.scl_type = this.typeList[index].dic_code;
            } else if(this.activeCardIndex == 2) {
                this.searchHighSchool.scl_type = this.typeList[index].dic_code;
            }
            this.resetGetSchoolListHandler();
		},
		activeTagHandler2(index) {
			this.activeTag2 = index;
            if(this.activeCardIndex == 0) {
                this.searchSchool.scl_nature = this.typeList1[index].dic_code;
            } else if(this.activeCardIndex == 1) {
                this.searchArtSchool.scl_nature = this.typeList1[index].dic_code;
            } else if(this.activeCardIndex == 2) {
                this.searchHighSchool.scl_nature = this.typeList1[index].dic_code;
            }
            this.resetGetSchoolListHandler();
		},
        activeTagHandler3(index) {
			this.activeTag3 = index;
            // this.searchArtSchool.scl_nature_type = this.typeList2[index].dic_code;
            if(this.activeCardIndex == 0) {
                this.searchSchool.scl_nature_type = this.typeList2[index].dic_code;
            } else if(this.activeCardIndex == 1) {
                this.searchArtSchool.scl_nature_type = this.typeList2[index].dic_code;
            } else if(this.activeCardIndex == 2) {
                this.searchHighSchool.scl_nature_type = this.typeList2[index].dic_code;
            }
            this.resetGetSchoolListHandler();
		},
        activeTagHandler4(index) {
			this.activeTag4 = index;
            this.searchArtSchool.art_type = this.typeList3[index].dic_code;
            this.resetGetSchoolListHandler();
		},
        activeTagHandler5(index) {
			this.activeTag5 = index;
            this.searchHighSchool.colleges_level = this.typeList4[index].dic_code;
            this.resetGetSchoolListHandler();
		},
        activeTagHandler6(index) {
			this.activeTag6 = index;
            this.searchHighSchool.doublehigh = this.typeList5[index].dic_code;
            this.resetGetSchoolListHandler();
		},
        activeTagHandler7(index) {
			this.activeTag7 = index;
            this.searchSchool.gradation = this.typeList6[index].dic_code;
            // if(index == '0') {
            //     this.activeTag3 = -1;
            //     if(this.activeCardIndex == 0) {
            //         this.searchSchool.scl_nature_type = '';
            //     } else if(this.activeCardIndex == 1) {
            //         this.searchArtSchool.scl_nature_type = '';
            //     } 
            // }
            this.resetGetSchoolListHandler();
		},
        activeTagHandler8(index) {
			this.activeTag8 = index;
            this.searchSchool.master_doctor = this.typeList7[index].dic_code;
            this.resetGetSchoolListHandler();
		},
        activeTagHandler9(index) {
			this.activeTag9 = index;
            this.searchSchool.doctor = this.typeList8[index].dic_code;
            this.resetGetSchoolListHandler();
		},
        activeTagHandler10(index) {
            this.activeTag10 = index;
            this.searchSchool.local_batch_type = this.typeList9[index].dic_code;
            this.resetGetSchoolListHandler();
        },
        searchSchoolListHandler() {
            this.currentPage = 1;
            let index = this.activeCardIndex;
            if (index == '0') {
                this.getSchoolListHandler('1');
            } else if (index == '1') {
                this.getArtSchoolListHandler('1');
            } else if (index == '2') {
                this.getHighSchoolListHandler('1');
            }
        },
        resetGetSchoolListHandler() {
            this.schoolList = [];
            this.currentPage = 1;
            this.totalData = 0;
            if(this.activeCardIndex == 0) {
                this.getSchoolListHandler('1');
            } else if(this.activeCardIndex == 1) {
                this.getArtSchoolListHandler('1');
            } else if(this.activeCardIndex == 2) {
                this.getHighSchoolListHandler('1');
            }
        },
        getSearchDicHandler() {
            getSearchDic().then(res => {
                res.data.edu_type.map( item => {
                    this.type_edu[item.dic_code] = item.dic_value
                })
                this.provinceList.push(...res.data.province);
                this.typeList.push(...res.data.scl_type);
                this.typeList1.push(...res.data.scl_nature);
                this.typeList2.push(...res.data.edu_type);
                this.typeList3.push(...res.data.art_type);
                this.typeList4.push(...res.data.colleges_level);
                this.typeList5.push(...res.data.doublehigh);
                // this.typeList5.push(...res.data.doublehight);
                this.typeList6.push(...res.data.gradation);
                this.typeList7.push(...res.data.master_doctor);
                this.typeList8.push(...res.data.doctor);
                this.typeList9.push(...res.data.local_batch_type);
            })
        },
        getSchoolListHandler(page) {
            let {scl_name='', province_id='', scl_type='', scl_nature='', scl_nature_type='', f211='', f985='', dual_class,gradation='',doctor='',master_doctor='',local_batch_type=''} = this.searchSchool;
            getSchoolList({scl_name, province_id, scl_type, scl_nature, scl_nature_type, f211, f985, dual_class, page,gradation,doctor,master_doctor,local_batch_type}).then(res => {
                const data = res.data;
                // console.log(data,'schoolData')
                this.totalData = data.count;
                let schoolList = [];
                if(data.count == 0) {
                    this.searchSchoolStatus = false;
                    return
                }
                this.searchSchoolStatus = true;
                data.data.forEach((item,index) => {
                    let obj = {};
                    let school_type = '';
                    let school_nature = '';
                    obj = item;
                    if(item.scl_type == '5000') {
                        school_type = '综合'
                    } else  if(item.scl_type == '5001') {
                        school_type = '理工'
                    } else  if(item.scl_type == '5002') {
                        school_type = '农林'
                    } else  if(item.scl_type == '5003') {
                        school_type = '医药'
                    } else  if(item.scl_type == '5004') {
                        school_type = '师范'
                    } else  if(item.scl_type == '5005') {
                        school_type = '语言'
                    } else  if(item.scl_type == '5006') {
                        school_type = '财经'
                    } else  if(item.scl_type == '5007') {
                        school_type = '政法'
                    } else  if(item.scl_type == '5008') {
                        school_type = '体育'
                    } else  if(item.scl_type == '5009') {
                        school_type = '艺术'
                    } else  if(item.scl_type == '5010') {
                        school_type = '民族'
                    } else  if(item.scl_type == '5011') {
                        school_type = '军事'
                    } else {
                        school_type = '其他'
                    }
                    if(item.scl_nature == '36000') {
                        school_nature = '公办'
                    } else if(item.scl_nature == '36001') {
                        school_nature = '民办'
                    } else if(item.scl_nature == '36002') {
                        school_nature = '中外合作办学'
                    }
                    // if (item.scl_nature_type == '6000') {
                    //     if(item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)) {
                    //         school_nature_type = '本科'
                    //     } else {
                    //         school_nature_type = '普通本科'
                    //     }
                    // } else if (item.scl_nature_type == '6001') {
                    //     if(item.is_doublehigh == '77') {
                    //         school_nature_type = '专科'
                    //     } else {
                    //         school_nature_type = '普通专科'
                    //     }
                    // } else if (item.scl_nature_type == '6002') {
                    //     school_nature_type = '中外合作办学'
                    // }
                    obj.school_type = school_type;
                    obj.school_nature = school_nature;
                    obj.school_nature_type = this.type_edu[item.scl_nature_type];
                    let findIndex =  this.compareSchoolList.indexOf(item.scl_id);
                    if(findIndex != -1) {
                        obj.pk =  true;
                    } else {
                        obj.pk =  false;
                    }
                    obj.show = false;
                    obj.logo = 'https://gaokao.zmpajx.com/pic/'+item.scl_id+'.jpg';
                    schoolList.push(obj);
                })
                this.schoolList = schoolList;
            })
        },
        getArtSchoolListHandler(page) {
            let {scl_name} = this.searchSchool;
            let {province_id, scl_type, scl_nature, scl_nature_type, art_type} = this.searchArtSchool;
            getArtSchoolList({scl_name, province_id, scl_type, scl_nature, scl_nature_type, art_type, page}).then(res => {
                const data = res.data;
                this.totalData = data.count;
                let schoolList = [];
                if(data.count == 0) {
                    this.searchSchoolStatus = false;
                    return
                }
                this.searchSchoolStatus = true;
                data.data.forEach((item,index) => {
                    let obj = {};
                    let school_type = '';
                    let school_nature = '';
                    obj = item;
                    if(item.scl_type == '5000') {
                        school_type = '综合'
                    } else  if(item.scl_type == '5001') {
                        school_type = '理工'
                    } else  if(item.scl_type == '5002') {
                        school_type = '农林'
                    } else  if(item.scl_type == '5003') {
                        school_type = '医药'
                    } else  if(item.scl_type == '5004') {
                        school_type = '师范'
                    } else  if(item.scl_type == '5005') {
                        school_type = '语言'
                    } else  if(item.scl_type == '5006') {
                        school_type = '财经'
                    } else  if(item.scl_type == '5007') {
                        school_type = '政法'
                    } else  if(item.scl_type == '5008') {
                        school_type = '体育'
                    } else  if(item.scl_type == '5009') {
                        school_type = '艺术'
                    } else  if(item.scl_type == '5010') {
                        school_type = '民族'
                    } else  if(item.scl_type == '5011') {
                        school_type = '军事'
                    } else {
                        school_type = '其他'
                    }
                    if(item.scl_nature == '36000') {
                        school_nature = '公办'
                    } else if(item.scl_nature == '36001') {
                        school_nature = '民办'
                    } else if(item.scl_nature == '36002') {
                        school_nature = '中外合作办学'
                    }
                    // if (item.scl_nature_type == '6000') {
                    //     if(item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)) {
                    //         school_nature_type = '本科'
                    //     } else {
                    //         school_nature_type = '普通本科'
                    //     }
                    // } else if (item.scl_nature_type == '6001') {
                    //     if(item.is_doublehigh == '77') {
                    //         school_nature_type = '专科'
                    //     } else {
                    //         school_nature_type = '普通专科'
                    //     }
                    // } else if (item.scl_nature_type == '6002') {
                    //     school_nature_type = '中外合作办学'
                    // }
                    obj.school_type = school_type;
                    obj.school_nature = school_nature;
                    obj.school_nature_type = this.type_edu[item.scl_nature_type];
                    let findIndex =  this.compareSchoolList.indexOf(item.scl_id);
                    if(findIndex != -1) {
                        obj.pk =  true;
                    } else {
                        obj.pk =  false;
                    }
                    obj.show = false;
                    obj.logo = 'https://gaokao.zmpajx.com/pic/'+item.scl_id+'.jpg';
                    schoolList.push(obj);
                })
                this.schoolList = schoolList;
            })
        },
        getHighSchoolListHandler(page) {
            let {scl_name} = this.searchSchool;
            let area = localStorage.getItem("area");
            let {scl_type, scl_nature, scl_nature_type, colleges_level, doublehigh, province} = this.searchHighSchool;
            console.log(this.searchHighSchool)
            getHighSchoolList({scl_name, scl_type, scl_nature, scl_nature_type, colleges_level, doublehigh, province, area, page}).then(res => {
                const data = res.data;
                this.totalData = data.count;
                let schoolList = [];
                if(data.count == 0) {
                    this.searchSchoolStatus = false;
                    return
                }
                this.searchSchoolStatus = true;
                data.data.forEach((item,index) => {
                    let obj = {};
                    let school_type = '';
                    let school_nature = '';
                    obj = item;
                    if(item.scl_type == '5000') {
                        school_type = '综合'
                    } else  if(item.scl_type == '5001') {
                        school_type = '理工'
                    } else  if(item.scl_type == '5002') {
                        school_type = '农林'
                    } else  if(item.scl_type == '5003') {
                        school_type = '医药'
                    } else  if(item.scl_type == '5004') {
                        school_type = '师范'
                    } else  if(item.scl_type == '5005') {
                        school_type = '语言'
                    } else  if(item.scl_type == '5006') {
                        school_type = '财经'
                    } else  if(item.scl_type == '5007') {
                        school_type = '政法'
                    } else  if(item.scl_type == '5008') {
                        school_type = '体育'
                    } else  if(item.scl_type == '5009') {
                        school_type = '艺术'
                    } else  if(item.scl_type == '5010') {
                        school_type = '民族'
                    } else  if(item.scl_type == '5011') {
                        school_type = '军事'
                    } else {
                        school_type = '其他'
                    }
                    if(item.scl_nature == '36000') {
                        school_nature = '公办'
                    } else if(item.scl_nature == '36001') {
                        school_nature = '民办'
                    } else if(item.scl_nature == '36002') {
                        school_nature = '中外合作办学'
                    }
                    // if (item.scl_nature_type == '6000') {
                    //     if(item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)) {
                    //         school_nature_type = '本科'
                    //     } else {
                    //         school_nature_type = '普通本科'
                    //     }
                    // } else if (item.scl_nature_type == '6001') {
                    //     if(item.is_doublehigh == '77') {
                    //         school_nature_type = '专科'
                    //     } else {
                    //         school_nature_type = '普通专科'
                    //     }
                    // } else if (item.scl_nature_type == '6002') {
                    //     school_nature_type = '中外合作办学'
                    // }
                    obj.school_type = school_type;
                    obj.school_nature = school_nature;
                    obj.school_nature_type = this.type_edu[item.scl_nature_type];
                    let findIndex =  this.compareSchoolList.indexOf(item.scl_id);
                    if(findIndex != -1) {
                        obj.pk =  true;
                    } else {
                        obj.pk =  false;
                    }
                    obj.show = false;
                    obj.logo = 'https://gaokao.zmpajx.com/pic/'+item.scl_id+'.jpg';
                    schoolList.push(obj);
                })
                this.schoolList = schoolList;
            })
        },
        addCompare(item,index) {
            let compareSchoolList = this.$store.state.user.compareSchoolList;
            if(compareSchoolList.length == 4) {
                this.$message({
                    message: '最多可添加4所院校',
                    type: 'warning'
                })
                return
            }
            this.showImage = true;
            this.showImageIndex = index;
            this.$set(this.schoolList, index, {...this.schoolList[index], pk: true});
            compareSchoolList.push(item.scl_id);
        },
        removeCompare(item,index) {
            this.$set(this.schoolList, index, {...this.schoolList[index], pk: false});
            let compareSchoolList = this.$store.state.user.compareSchoolList;
            let removeIndex = compareSchoolList.indexOf(item.scl_id);
            compareSchoolList.splice(removeIndex,1);
        },
        beforeEnter (el) {
            let schoolImg = this.$refs.schoolImg[this.showImageIndex];
            let rect = schoolImg.getBoundingClientRect();
            el.style.transform = 'translate(10px,10px)';
            el.style.position = "absolute";
            el.style.left = (rect.x) +'px';
            el.style.top = (rect.y) +'px';
            el.style.zIndex = '9999';
        },
        // 进入中
        enter (el, done) {
            // 需要调用元素的offset操作,才有过渡的效果,否则会马上实现过渡
            el.offsetWidth;
            let x = document.documentElement.clientWidth;
            let y = document.documentElement.clientHeight;
            let schoolImg = this.$refs.schoolImg[this.showImageIndex];
            let rect = schoolImg.getBoundingClientRect();
            el.style.position = "fixed";
            el.style.right = "16px";
            el.style.bottom = "332px";
            el.style.transform = 'translate('+(x-90-rect.x)+'px,'+(y-500-rect.y)+'px)';
            el.style.transition = "all 0.5s cubic-bezier(.42, 0, .58, 1)";
            done()
        },
        // 进入后
        afterEnter () {
            this.showImage = !this.showImage
        },
        nofindImg(index) {
            this.schoolList[index].logo = require("../../assets/images/scl_default.png");
		},
        handleChangeCard(e) {
            let index = e.index;
            this.showImage = false,
            this.showImageIndex = null,
            this.activeTag = 0;
            this.activeTag1 = 0;
            this.activeTag2 = 0;
            this.activeTag3 = 0;
            this.activeTag4 = 0;
            this.activeTag5 = 0;
            this.activeTag6 = 0;
            this.showSearchAll = false;
            Object.assign(this.$data.searchSchool, this.$options.data().searchSchool)
            Object.assign(this.$data.searchArtSchool, this.$options.data().searchArtSchool)
            Object.assign(this.$data.searchHighSchool, this.$options.data().searchHighSchool)
            this.activeCardIndex = index;
            this.currentPage = 1;
            this.schoolList = [];
            if (index == '0') {
                // const find_tmp = this.typeList2.findIndex(val => { return val.dic_value == '全部'})
                // if(find_tmp !== -1) {
                //     this.typeLis2.splice(find_tmp, 1)
                // }
                // this.typeList2.splice(0, 1)
                this.getSchoolListHandler('1');
            } else if (index == '1') {
                // this.activeTag3 = 0;
                // const type = [...this.typeList2]
                // const find_tmp = type.findIndex(val => { return val.dic_value == '全部'})
                // console.log(find_tmp)
                // if(find_tmp !== -1) {
                //    type.splice(find_tmp, 1)
                // }
                // type.unshift({dic_value:'全部'})
                // this.typeList2 = [...type]
                this.getArtSchoolListHandler('1');
            } else if (index == '2') {
                // this.activeTag3 = 0;
                // const type = [...this.typeList2]
                // const find_tmp = type.findIndex(val => { return val.dic_value == '全部'})
                // console.log(find_tmp)
                // if(find_tmp !== -1) {
                //    type.splice(find_tmp, 1)
                // }
                // type.unshift({dic_value:'全部'})
                // this.typeList2 = [...type]
                this.getHighSchoolListHandler('1');
            } 
        },
        getDiffSchoolListHandler() {
            let index = this.activeCardIndex;
            if (index == '0') {
                this.getSchoolListHandler(this.currentPage);
            } else if (index == '1') {
                this.getArtSchoolListHandler(this.currentPage);
            } else if (index == '2') {
                this.getHighSchoolListHandler(this.currentPage);
            }  
        }
	}
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .zy-img {
        @include gwidth;
        margin-top: 10px;
    }
    .zy-school {
        @include gwidth;
        .el-col-7 {
        width: 32.5%;
        }
        .el-col-16 {
        position: relative;
        padding: 0 20px 0 0;
        }
    }
    .search-img {
        margin-bottom: 24px;
        height: 44px;
        line-height: 44px;
        img {
            width: 32px;
            height: 32px;
            float: right;
            cursor: pointer;
        }
        input {
            background: #fff!important;
        }
        button {
            width: 100px;
            height: 44px;
            border: none!important;
            background: linear-gradient(270deg,$common-color, #60aaff 99%);
            border-radius: 8px;
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            border: none;
            margin-left: 16px;
            position: relative;
            top: 1px;
        }
    }
    .rank-box {
        border: none;
        background: #f5f7fa;
        box-shadow: none!important;
        margin-top: 24px;
    }
    .province-list {
        @include gflex;
        font-size: 0;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 6px;
        .title-box {
            width: 78px;
            font-size: 14px;
            text-align: right;
            color: #909399;
            margin-top: 3px;
        }
        a {
            display: inline-block;
            font-size: 14px;
            color: #5e6166;
            cursor: pointer;
            text-align: center;
            padding: 3px 5px;
            margin-bottom: 10px;
        }
        a:hover {
            color: $common-color;
        }
        a:not(:nth-child(13n)) {
            margin-right: 12px;
        }
        .active-tag {
            color: #ffffff!important;
            background: $common-color;
            border-radius: 4px;
        }
        .province-name {
            @include gflex;
            width: calc(100% - 4px);
            justify-content: flex-start;
            flex-wrap: wrap;
        }
    }
    .choice-box {
		font-size: 14px;
		margin-top: 4px;
		color: $common-color;
		cursor: pointer;
		i {
			margin-left: 5px;
		}
	}
    .collapse-list {
        height: 104px;
        padding: 20px 0;
        position: relative;
        box-sizing: border-box;
    }
    .collapse-box {
		width: 100%;
        border-top: 1px solid #f0f2f5;
        margin-top: 24px;
		font-size: 0;
		img {
			width: 64px;
			height: 64px;
		}
        .active-img-inner{
            width: 64px;
            height: 64px;
            border-radius: 50%;
            background-color: rgb(0,160,220);
        }
		.el-col-3 {
			width: 11%;
		}
        .el-col-4 {
            float: right;
        }
        .zytb-school-name {
            font-size: 18px;
            font-weight: 600;
            color: #2c2e33;
            margin-bottom: 5px;
            .zytb-school-title {
                font-size: 18px;
                font-weight: 600;
                color: #2c2e33;
            }
        }
        .zytb-school-tag span {
            display: inline-block;
            padding: 3px 8px;
            font-size: 12px;
            color: #909399;
            height: 22px;
            background: #f0f2f5;
            border-radius: 4px;
            line-height: 22px;
            margin-right: 4px;
        }
        .zytb-school-major {
            color: $common-color;
            font-size: 14px;
            margin-top: 20px;
            position: relative;
            right: -6px;
        }
        .zytb-school-name img {
            width: 16px;
            height: 16px;
            position: relative;
            top: 2px;
            left: 5px;
            margin-left: 5px;
        }
        .zytb-school-name span {
            color: #909399;
            font-size: 12px;
            font-weight: 400;
            position: relative;
            top: -2px;
            left: 5px;
        }
        .zytb-school-tag {
            margin-top: 10px;
        }
        button {
            width: 100px;
            height: 30px;
            border: 1px solid $common-color;
            border-radius: 5px;
            color: $common-color!important;
            font-size: 14px;
            text-align: center;
            line-height: 30px;
            padding: 0;
            margin-top: 15px;
			background-color: #fff;
        }
        .el-col-4 {
            text-align: right;
        }
        .school-compare,.school-compare-diff {
            img {
                width: 12px;
                height: 12px;
            }
        }
        .school-compare-diff {
            color: #ffffff!important;
            background: $common-color!important;
            border: 1px solid $common-color!important;
        }
        button:hover {
            background-color: #fff;
        }
        .con-line {
            width: 650px;
            height: 1px;
            background: #f0f2f5;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }
    .collapse-list:hover {
        .zytb-school-title {
            color: $common-color;
            cursor: pointer;
        }
    }
    .zyb-box {
        position: absolute;
        right: 0;
    }
    .no-data-box {
        text-align: center;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: 115px;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
        }
    }
</style>